<template>
  <v-container>
    <div class="complaints-list">
      <v-row class="my-2">
        <v-col>
          <h2 class="text-no-wrap">
            オンライン相談：主訴一覧
          </h2>
        </v-col>
        <v-col class="pl-0 d-flex justify-end align-center">
          <div class="picker-align-right">
            <month-picker
              v-model:selectedDate="selectedDate"
              @on-month-changed="saveSelectedDate"
            />
          </div>
          <v-btn
            v-if="published"
            variant="flat"
            prepend-icon="custom:download"
            height="40"
            border="md"
            @click="downloadCSV"
            class="text-glance-primary ml-2 font-weight-bold border-current"
          >
            CSVダウンロード
          </v-btn>
        </v-col>
      </v-row>
      <template v-if="published">
        <v-table class="table-grid font-size-10-rem">
          <thead class="height-40">
            <tr>
              <th
                class="w-15 text-center font-weight-bold"
              >
                相談相手
              </th>
              <th
                class="w-20 text-center font-weight-bold"
              >
                サービス種別
              </th>
              <th
                class="text-center font-weight-bold"
              >
                主訴
              </th>
              <th
                class="w-25 text-center font-weight-bold"
              >
                子の年齢（小児科のみ）
              </th>
            </tr>
          </thead>
          <tbody class="height-45">
            <template
              v-for="complaint in complaints"
              :key="complaint.id"
            >
              <tr
                :class="[isSyounika(complaint.departmentType) ? 'bg-syounika' : 'bg-obstetrics']"
              >
                <td class="text-center">
                  {{ complaint.departmentTypeI18n }}
                </td>
                <td class="text-center">
                  {{ complaint.reservationTypeI18n }}
                </td>
                <td>
                  <!-- eslint-disable-next-line vue/no-v-html -->
                  <span v-html="newLineCodeToBr(complaint.complaint)" />
                </td>
                <td class="text-center">
                  {{ complaint.childAge }}
                </td>
              </tr>
            </template>
          </tbody>
        </v-table>
      </template>
      <template v-else>
        <unpublished-message />
      </template>
    </div>
  </v-container>
</template>

<script lang="ts">
import { defineComponent, computed, onMounted } from "vue"
import { useStore } from "../stores/index"
import { textFormatter } from "../service/text_formatter"
import monthPicker from "./shared/MonthPicker.vue"
import unpublishedMessage from "./shared/UnpublishedMessage.vue"

export default defineComponent({
  name: "ComplaintListPage",
  components: {
    monthPicker,
    unpublishedMessage
  },
  setup() {
    // vuex
    const store = useStore()
    const newLineCodeToBr = textFormatter().newLineCodeToBr

    // data
    const complaints = computed(() => store.getters.complaints)
    const published = computed(() => store.getters.complaintsPublished)
    const selectedDate = computed(() => new Date(store.getters.selectedComplaintsDate))

    const isSyounika = (departmentType: string) => {
      if (departmentType == "pediatrician") {
        return true
      }

      return false
    }

    const saveSelectedDate = async (selectedValue: Date) => {
      await store.dispatch("commitSelectedComplaintsDate", selectedValue)
    }

    const downloadCSV = async () => {
      await store.dispatch("downloadComplaints")
    }

    onMounted(() => {
      store.dispatch("commitSelectedComplaintsDate", selectedDate.value)
    })

    return {
      selectedDate,
      complaints,
      published,
      saveSelectedDate,
      newLineCodeToBr,
      isSyounika,
      downloadCSV
    }
  }
})
</script>
